<template>
  <span>{{ display }}</span>
</template>

<script type="text/babel">
export default {
  props: {
    number: {
      type: [String, Number],
      default: "",
    },
  },

  computed: {
    display() {
      let input = this.number.toString();

      if (input.startsWith("+61")) {
        // Somewhat hardcode to remove international number for Australia
        input = input.replace("+61", "0");
      }

      if (input.length === 10) {
        if (input.startsWith("04") || input.startsWith("1300") || input.startsWith("1800")) {
          // Mobile or service numbers
          return input.substring(0, 4) + " " + input.substring(4, 7) + " " + input.substring(7, 10);
        }

        // Phone with state prefix
        return input.substring(0, 2) + " " + input.substring(2, 6) + " " + input.substring(6, 10);
      }

      if (input.length === 8) {
        // Phone without state prefix
        return input.substring(0, 4) + " " + input.substring(4, 8);
      }

      if (input.length === 6 && input.startsWith("13")) {
        // 13 numbers
        return input.substring(0, 3) + " " + input.substring(3, 6);
      }

      return this.number;
    },
  },
};
</script>
